import axios from "@/lib/axios";

const getLostNonWarranty = () => {
  return axios.get("/facility/flat_rates/lost_non_warranty");
}

export default getLostNonWarranty;